import { PageContainer } from "@/components/layout/PageContainer";
import { Card } from "@/components/ui/card";
import { Video } from "lucide-react";
import VideoPlayer from "@/components/demo/VideoPlayer";

const tutorials = [
  { 
    title: "Aging In Place With Smarter Care",
    description: "Discover how Scienza Health is transforming homes into cognitive health hubs, enabling seniors to age in place with dignity and comprehensive care support.",
    videoId: "5kfoCzK9omY"
  },
  { 
    title: "Empowering Families: Recognizing Cognitive Health Challenges",
    description: "In this video, we explore how Scienza Health supports families and caregivers in managing cognitive health. Learn about early signs of cognitive decline, actionable insights, and tools to provide better care for your loved ones. Together, we can make a difference. 💙 #CognitiveHealth",
    videoId: "oijKykt2ynQ"
  },
  { 
    title: "The 5 Signs of Cognitive Decline",
    description: "5 Signs of Cognitive Decline: When to Take Action\nDiscover the key signs of cognitive decline, from memory loss to changes in mood, and learn how Scienza Health helps families and caregivers take early, proactive steps toward better cognitive health. 🧠 #CognitiveHealth #EarlyDetection",
    videoId: "2euOAQNlYQ8"
  },
  { 
    title: "Transforming Access To Cognitive Assessments and Management with AI",
    videoId: "2fUsKc_xR4E"
  }
];

export default function VideoTutorials() {
  return (
    <PageContainer>
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Video className="w-6 h-6 text-primary" />
          </div>
          <h1 className="text-3xl font-bold">Video Tutorials</h1>
        </div>

        <div className="grid gap-8">
          {tutorials.map((tutorial) => (
            <Card key={tutorial.title} className="p-6">
              <h2 className="text-xl font-semibold mb-4">{tutorial.title}</h2>
              {tutorial.description && (
                <p className="text-gray-600 mb-4 whitespace-pre-line">{tutorial.description}</p>
              )}
              {tutorial.videoId ? (
                <div className="relative aspect-video w-full">
                  <iframe
                    className="absolute inset-0 w-full h-full rounded-lg"
                    src={`https://www.youtube.com/embed/${tutorial.videoId}?autoplay=0&mute=1&controls=1`}
                    title={tutorial.title}
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              ) : (
                <VideoPlayer />
              )}
            </Card>
          ))}
        </div>
      </div>
    </PageContainer>
  );
}